/* tslint:disable */

//  This file was generated from apps/appsync-bff/appsync/resources/schema.graphql
//  and should not be edited manually.

export const userAuthorizations = /* GraphQL */ `
  query LookupUserAuthorizations($userAuthorizations: [UserAuthorizationInput!]!) {
    userAuthorizations(userAuthorizations: $userAuthorizations) {
      action
      resourceType
      resourceIdentifier
      allowed
    }
  }
`;

export const lookupOperationalEntity = /* GraphQL */ `
  query LookupOperationalEntity($id: String!) {
    entity: operationalEntityById(id: $id) {
      id
      sources {
        sourceId
        sourceType
      }
      boidAssignments {
        businessOperationType
        businessOperationId
        commonOrgId
      }
      organizationInformation {
        dbaName
        legalName
        status
        telecomNumbers
        address {
          streetAddressLine1
          streetAddressLine2
          city
          state
          zip
          country
        }
      }
      oems {
        abbreviation
        id
        locationId
        nameplateDescription
      }
      parent {
        id
        organizationInformation {
          dbaName
        }
        statuses
      }
      statuses
      enterpriseEntitlementsV2 {
        featureName
        featureId
        status
      }
      isComplex
      tenantId
    }
  }
`;

export const lookupOperationalEntitySummaries = /* GraphQL */ `
  query LookupOperationalEntitySummaries($ids: [String]!) {
    entities: operationalEntitiesByIds(ids: $ids) {
      id
      statuses
      organizationInformation {
        dbaName
        legalName
        status
      }
    }
  }
`;

export const lookupOperationalEntityByIdWithFallback = /* GraphQL */ `
  query LookupOperationalEntityByIdWithFallback($id: String!) {
    entity: operationalEntityByIdWithFallback(id: $id) {
      id
      sources {
        sourceId
        sourceType
      }
      boidAssignments {
        businessOperationType
        businessOperationId
        commonOrgId
      }
      organizationInformation {
        dbaName
        legalName
        status
        telecomNumbers
        address {
          streetAddressLine1
          streetAddressLine2
          city
          state
          zip
          country
        }
      }
      oems {
        abbreviation
        id
        locationId
        nameplateDescription
      }
      parent {
        id
        organizationInformation {
          dbaName
        }
        statuses
      }
      statuses
      enterpriseEntitlementsV2 {
        featureName
        featureId
        status
      }
      isComplex
    }
  }
`;

export const searchOperationalEntities = /* GraphQL */ `
  query SearchOperationalEntities($query: String!) {
    searchResult: operationalSearch(query: $query) {
      results {
        id
        tenantId
        organizationInformation {
          dbaName
          address {
            city
            state
          }
        }
        oems {
          abbreviation
          id
          locationId
          nameplateDescription
        }
        boidAssignments {
          businessOperationType
          businessOperationId
        }
        statuses
      }
    }
  }
`;

export const lookupOperationalHierarchy = /* GraphQL */ `
  query LookupOperationalHierarchy($id: ID!) {
    hierarchyNode: operationalEntityRootById(id: $id) {
      ...OperationalEntityNode
      children {
        ...OperationalEntityNode
        children {
          ...OperationalEntityNode
          children {
            ...OperationalEntityNode
            children {
              ...OperationalEntityNode
              children {
                ...OperationalEntityNode
                children {
                  ...OperationalEntityNode
                  children {
                    ...OperationalEntityNode
                    children {
                      ...OperationalEntityNode
                      children {
                        ...OperationalEntityNode
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment OperationalEntityNode on OperationalEntity {
    id
    organizationInformation {
      dbaName
      address {
        streetAddressLine1
        streetAddressLine2
        city
        state
        zip
        country
      }
    }
    oems {
      abbreviation
      id
      nameplateDescription
    }
    statuses
  }
`;

export const lookupClientEntitiesByIds = /* GraphQL */ `
  query LookupClientEntitiesByIds($ids: [String]!) {
    entities: clientEntitiesByIds(ids: $ids) {
      subaccounts {
        subAccountId
        subAccountType
        subAccountStatus
        assignedCommonOrgId
      }
      caId
      custName
      custType
      custPhoneNumber
      addresses {
        addrLine1
        addrLine2
        postalCd
        city
        provinceCd
        primaryFlag
        countryCd
      }
      clientNameplates {
        oemAbbreviation
        nameplateDesc
        oemId
        oemLocationId
      }
    }
  }
`;

export const lookupClientEntity = /* GraphQL */ `
  query LookupClientEntity($id: String) {
    entity: clientEntityById(id: $id) {
      caId
      custName
      custType
      custParentId
      custUltimateParentId
      custLegalName
      custStatus
      custPhoneNumber
      addresses {
        addrLine1
        addrLine2
        city
        provinceCd
        postalCd
        countryCd
        primaryFlag
      }
      clientNameplates {
        oemId
        oemAbbreviation
        nameplateDesc
        oemLocationId
      }
      subaccounts {
        subAccountType
        subAccountId
        assignedCommonOrgId
      }
      mappedOperationalEntities {
        id
      }
    }
  }
`;

export const lookupClientEntityWithHierarchy = /* GraphQL */ `
  query LookupClientEntityWithHierarchy($id: String) {
    entity: clientEntityById(id: $id) {
      ...ClientHierarchyNodeFull
      hierarchy {
        ...ClientHierarchyNodeFull
        children {
          ...ClientHierarchyNodeFull
          children {
            ...ClientHierarchyNodeFull
            children {
              ...ClientHierarchyNodeFull
              children {
                ...ClientHierarchyNodeFull
                children {
                  ...ClientHierarchyNodeFull
                  children {
                    ...ClientHierarchyNodeFull
                    children {
                      ...ClientHierarchyNodeFull
                      children {
                        ...ClientHierarchyNodeFull
                        children {
                          ...ClientHierarchyNodeFull
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment ClientHierarchyNodeFull on Client {
    caId
    custName
    custType
    custParentId
    custLegalName
    custStatus
    custPhoneNumber
    addresses {
      addrLine1
      addrLine2
      city
      provinceCd
      postalCd
      countryCd
      primaryFlag
    }
    clientNameplates {
      oemId
      oemAbbreviation
      nameplateDesc
      oemLocationId
    }
    mappedOperationalEntities {
      id
      tenantId
      organizationInformation {
        dbaName
      }
      isComplex
    }
  }
`;

export const searchClientHierarchy = /* GraphQL */ `
  query SearchClientHierarchy($query: String!) {
    results: clientHierarchySearch(query: $query) {
      caId
      custLegalName
      custStatus
      custName
      custType
      custPhoneNumber
      addresses {
        primaryFlag
        provinceCd
        city
      }
      clientNameplates {
        nameplateDesc
        oemAbbreviation
        oemId
        oemLocationId
      }
      subaccounts {
        subAccountType
        subAccountId
      }
    }
  }
`;

export const lookupClientEntityById = /* GraphQL */ `
  query LookupClientEntityById($id: String) {
    entity: clientEntityById(id: $id) {
      caId
      custName
      custType
      custParentId
      custUltimateParentId
      custLegalName
      custStatus
      custPhoneNumber
      addresses {
        addrLine1
        addrLine2
        city
        provinceCd
        postalCd
        countryCd
        primaryFlag
      }
      clientNameplates {
        oemId
        oemAbbreviation
        nameplateDesc
        oemLocationId
      }
      subaccounts {
        subAccountType
        subAccountId
        subAccountStatus
      }
      mappedOperationalEntities {
        id
        organizationInformation {
          dbaName
        }
        isComplex
      }
      hierarchy {
        ...ClientHierarchyNodeById
        children {
          ...ClientHierarchyNodeById
          children {
            ...ClientHierarchyNodeById
            children {
              ...ClientHierarchyNodeById
              children {
                ...ClientHierarchyNodeById
                children {
                  ...ClientHierarchyNodeById
                  children {
                    ...ClientHierarchyNodeById
                    children {
                      ...ClientHierarchyNodeById
                      children {
                        ...ClientHierarchyNodeById
                        children {
                          ...ClientHierarchyNodeById
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment ClientHierarchyNodeById on Client {
    caId
    custName
    custType
    custLegalName
    custStatus
    addresses {
      primaryFlag
      addrLine1
      addrLine2
      city
      provinceCd
      countryCd
      postalCd
    }
    mappedOperationalEntities {
      id
      isComplex
      organizationInformation {
        dbaName
      }
    }
  }
`;
